/**
 * Onboarding session status types
 */
export const ONBOARDING_STATUS = {
    NOT_STARTED: 'not_started',
    IN_PROGRESS: 'in_progress',
    COMPLETED: 'completed',
    SKIPPED: 'skipped',
    ABANDONED: 'abandoned',
    QUICK_START_COMPLETE: 'quick_start_complete',
};
/**
 * Onboarding paths
 */
export const ONBOARDING_PATH = {
    QUICK: 'quick',
    FULL: 'full',
};
/**
 * Onboarding steps
 */
export const ONBOARDING_STEP = {
    CHOOSE: 'choose',
    COMPANY: 'company',
    SCM: 'scm',
    FEATURES: 'features',
    WORK_ITEMS: 'workitems',
    POLICIES: 'policies',
    STANDARDS: 'standards',
    MCP: 'mcp',
    REPORTING: 'reporting',
    REPOS: 'repos',
    SUMMARY: 'summary',
};
/**
 * Step sequences for each path
 */
export const ONBOARDING_SEQUENCES = {
    [ONBOARDING_PATH.QUICK]: [
        ONBOARDING_STEP.CHOOSE,
        ONBOARDING_STEP.COMPANY,
        ONBOARDING_STEP.SCM,
        ONBOARDING_STEP.REPOS,
    ],
    [ONBOARDING_PATH.FULL]: [
        ONBOARDING_STEP.CHOOSE,
        ONBOARDING_STEP.COMPANY,
        ONBOARDING_STEP.SCM,
        ONBOARDING_STEP.WORK_ITEMS,
        ONBOARDING_STEP.STANDARDS,
        ONBOARDING_STEP.MCP,
        ONBOARDING_STEP.REPOS,
    ],
};
/**
 * Maximum accepted length for the onboarding Company Name field.
 * Matches the organization name limit in `orgNameSchema`.
 */
export const ONBOARDING_COMPANY_NAME_MAX_LENGTH = 100;
/**
 * Quick Start default feature preferences
 */
export const QUICK_START_DEFAULTS = {
    enabled_features: [
        'ai-code-reviews',
        'instant-metrics',
        'team-dashboards',
        'engineer-coaching',
        'gamification',
    ],
};
/**
 * Review Policy Preset Definitions
 */
export const REVIEW_PRESETS = {
    LENIENT: {
        strictness_level: 'lenient',
        quality_threshold: 50,
        review_frequency: 'on_every_pr',
        auto_comment: false,
        block_merge: false,
    },
    BALANCED: {
        strictness_level: 'balanced',
        quality_threshold: 70,
        review_frequency: 'on_every_pr',
        auto_comment: false,
        block_merge: false,
    },
    STRICT: {
        strictness_level: 'strict',
        quality_threshold: 90,
        review_frequency: 'on_every_pr',
        auto_comment: true,
        block_merge: true,
    },
};
/**
 * Significance criteria for "Significant only" reviews
 */
export const SIGNIFICANCE_CRITERIA = {
    MIN_LINES: 50,
    MIN_FILES: 3,
};
/**
 * Quick Start default review policies
 */
export const QUICK_START_POLICIES = {
    ...REVIEW_PRESETS.BALANCED,
};
//# sourceMappingURL=onboarding.js.map